// extracted by mini-css-extract-plugin
module.exports = {"layout":"LayoutWithHeaderAndFooter_layout__oizz0"};